// Placeholder shapes for content that is on its way: they hold the layout so
// nothing jumps when the data lands. Hidden from screen readers; the
// surrounding container says it is busy.
export function Skeleton({ className = '' }: { className?: string }) {
  return <span aria-hidden="true" className={`block rounded bg-slate-200/70 animate-pulse motion-reduce:animate-none ${className}`} />;
}

// A document page on first load: the header card's label/value grid and a
// few line rows, in the real cards' frame.
export function DocumentSkeleton() {
  return (
    <div aria-busy="true" className="space-y-cg">
      <span role="status" className="sr-only">Loading…</span>
      <div aria-hidden="true" className="rounded-card border border-border bg-surface shadow-card p-4">
        <Skeleton className="h-4 w-40 mb-3" />
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-x-8 gap-y-2">
          {Array.from({ length: 12 }, (_, i) => (
            <div key={i} className="flex items-center gap-3">
              <Skeleton className="h-3 w-20" />
              <Skeleton className="h-[26px] flex-1" />
            </div>
          ))}
        </div>
      </div>
      <div aria-hidden="true" className="rounded-card border border-border bg-surface shadow-card p-4 space-y-2">
        {Array.from({ length: 4 }, (_, i) => <Skeleton key={i} className="h-[26px] w-full" />)}
      </div>
    </div>
  );
}
